import type { ReactNode } from 'react';
import { AgxButton, AgxSpacer, Icon_Arrow } from '@urbanx/agx.ui-components2';
import { Link } from 'react-router-dom';

interface MarketingSubpageToolbarProps {
  backButtonId: string;
  onBack?: () => void;
  backLink?: string;
  children?: ReactNode;
}

const MarketingSubpageToolbar = ({
  backButtonId,
  onBack,
  backLink,
  children,
}: MarketingSubpageToolbarProps) => {
  return (
    <AgxSpacer
      direction="horizontal"
      gap="spacing-2xl"
      contentJustification="space-between"
      contentAlignment="center"
      className="borderBottomContainer marketingSubpageToolbar"
    >
      <AgxButton
        id={backButtonId}
        text="Back to Marketing"
        size="large"
        variant="naked"
        onClick={onBack}
        renderLink={backLink ? (props) => <Link to={backLink} {...props} /> : undefined}
        leftIcon={<Icon_Arrow direction="left" />}
      />
      {children && (
        <AgxSpacer
          direction="horizontal"
          gap="spacing-xl"
          contentJustification="end"
          className="marketingSubpageToolbarActions"
        >
          {children}
        </AgxSpacer>
      )}
    </AgxSpacer>
  );
};

export default MarketingSubpageToolbar;
